import { render, staticRenderFns } from "./EdgeVideo.vue?vue&type=template&id=68beebd4&scoped=true&"
import script from "./EdgeVideo.vue?vue&type=script&lang=ts&"
export * from "./EdgeVideo.vue?vue&type=script&lang=ts&"
import style0 from "./EdgeVideo.vue?vue&type=style&index=0&id=68beebd4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68beebd4",
  null
  
)

export default component.exports